<template>

  <div  @click="$emit('click', $event)" @dblclick="$emit('dblclick', $event)">
    <!--v-card dense style="background-color: rgba(242, 242, 242, 1); margin-top: 10px">
    <v-card-text-->
    <v-expansion-panels v-if="localValue.i18n" style="z-index: 0; margin-top: 10px; ">
      <v-expansion-panel>
        <v-expansion-panel-header style="background-color: #eee;">
          <div>
            <v-icon>mdi-form-textbox</v-icon>
            <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
              {{ index }}</b>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content style="background-color: #eee; padding-top:10px; z-index: 0">
          <v-tabs dense v-model="activeTab" background-color="primary" dark v-if="localValue.i18n">
            <v-tab dense v-for="lang in languages" :key="lang">

              <div class="draggable-tab" draggable="true" @dragstart="onDragStart(lang)" @dragover.prevent
                @drop="onDrop(lang)">
                {{ lang.toUpperCase() }}
                <v-icon small color="green" v-if="getTransValue(lang)">mdi-checkbox-marked-outline</v-icon>
                <v-icon small color="red" v-if="!getTransValue(lang)">mdi-square-outline</v-icon>
              </div>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab" v-if="localValue.i18n">
            <v-tab-item v-for="lang in languages" :key="lang">
              <v-card flat>
                <v-card-text style="min-height: 50px">
                  <v-text-field hide-details :label="'(' + lang + ') ' + index" 
                    :value="getTransValue(lang)"
                    @input="setTransValue(lang, $event)" clearable>
                    <v-icon slot="prepend"> mdi-text-short </v-icon>
                  </v-text-field>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </v-expansion-panel-content>

      </v-expansion-panel>
    </v-expansion-panels>


    <v-expansion-panels v-if="!localValue.i18n" style="z-index: 0; margin-top: 10px; ">
      <v-expansion-panel>
        <v-expansion-panel-header style="background-color: #eee;">
          <div>
            <v-icon>mdi-form-textbox</v-icon>
            <b style="font-size: 14px; font-weight: 600; padding-left: 10px">
              {{ index }}</b>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content style="background-color: #fff; padding-top:10px; z-index: 0">
          <v-text-field hide-details :label="index"
          __v-model="localValue.value" 
          :value="localValue.value"
          @input="val => updateChild(val)"
          clearable>

            <!--v-icon slot="prepend"> mdi-text-short </v-icon-->
          </v-text-field>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>

</template>

<script>
// let { getList, getDetail } = require("@/api/base_entity");

const { translate } = require("@/api/translate");

export default {
  props: {
    value: { type: Object },
    index: { type: String, default: "" },
    entityId: { type: Number },
    entity: { type: String },
    i18n: { type: Boolean, default: false },
    languages: { type: Array, default: () => ["EN", "IT", "DE", "FR", "ES"] }
  },
  data() {
    return {
      activeTab: 0,
      dragIndex: null,
      localValue: this.value || {type: 'cms-input', value: null, trans: {}, i18n: this.i18n},
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.localValue = newValue || this.localValue;
      },
      deep: true,
    }
  },
  methods: {
    updateChild(newFieldValue) {
      this.localValue.value = newFieldValue;
      this.$emit('input', JSON.parse(JSON.stringify(this.localValue)));
    },
    getTransValue(lang) {
      return this.localValue && this.localValue.trans ? this.localValue.trans[lang] : '';
    },
    setTransValue(lang, newValue) {
      if (!this.localValue.trans) {
        this.localValue.trans = {}
      }
      this.localValue.trans[lang] = newValue;
      this.$emit("input", JSON.parse(JSON.stringify(this.localValue)));
    },
    onDragStart(index) {
      this.dragIndex = index;
    },
    async onDrop(index) {
      const a = await translate(this.localValue.trans[this.dragIndex], this.dragIndex, index)
      this.setTransValue(index, a.translatedText)
    },
  },
};
</script>

<style></style>